import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

@Injectable()
export class ExcelReader {
    
    public async readExcelFile(file: File): Promise<any[]> {
        return new Promise<any[]>((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event: any) => {
                const data = new Uint8Array(event.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const excelData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
                resolve(excelData);
            };
            reader.onerror = (event: any) => {
                reject(event.target.error);
            };
            reader.readAsArrayBuffer(file);
        });
    }

    public getExcelHeaders(excelData: string[][]): string[] {
        const headers = excelData[0].filter(header => header && header.length > 0);
        return headers;
    }

    public getRows(excelData: string[][]): string[][] {
       return excelData.slice(1).filter(row => row.length).map(row => row?.filter(cell => cell?.toString()?.length));
    }
}